<template>
    <div :class="{
        logged:isLogged,
        [body_classes]:true
        }"
    >
        <nav
            :style="{
            background:`${custom_header_background}`,
             borderBottom: `${border_height}px solid white`
             }"
        >
            <div class="nav-wrapper nav_friending">
                <!--                <button @click="toggleLangHandler">Toggle Lang</button>-->
                <!-- no auth -->
                <router-link v-if="!isLogged" to="/" class="brand-logo center">
                    <img src="../assets/img/logo_nav.svg" alt="nav logo">
                </router-link>
                <!-- auth -->
                <template v-else>
                    <router-link to="/events-app" class="brand_logo">
                        <img src="../assets/img/logo_nav.svg" alt="nav logo">
                    </router-link>
                    <div class="nav_menu_wrapper">
                        <div class="nav_menu">
                            <router-link :to="{name: 'Events'}">{{ $t(`MainSlot['Events']`) }}</router-link>
                            <router-link :to="{name: 'Calendar'}">{{ $t(`MainSlot['My Calendar']`) }}</router-link>
                            <router-link :to="{name: 'Friends'}">{{ $t(`Friends['Friendzone']`) }}</router-link>
                        </div>

                        <!-- Dropdown Trigger -->
                        <a class='dropdown-trigger-main-menu btn white logout' :class="{'opened': dropdown_open}"
                           id="user_menu_desktop"
                           data-target="dropdown">

                            <div class="avatar-image"
                                 :style="{background:avatar_menu_background}"
                            ></div>
                            <img v-if="dropdown_open" src="../assets/img/up.svg" alt="up icon">
                            <img v-else src="../assets/img/down.svg" alt="down icon">
                        </a>

                        <!-- dropdown menu headers -->
                        <ul id="dropdown" ref="dropdown" class='dropdown-content'>
                            <!--                            <li class="flex first">-->
                            <!--                                <a href="#" class="flex">-->
                            <!--                                    <img src="../assets/img/invite.svg" alt="invite icon">-->
                            <!--                                    <div class="dropdown-text">{{ $t(`MainSlot['Invite a friend']`) }}</div>-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                            <li class="flex">
                                <router-link to="/profile" class="flex">
                                    <img src="../assets/img/user_mobile_icon.svg" alt="user icon">
                                    <div class="dropdown-text">{{ $t(`MainSlot['My profile']`) }}</div>
                                </router-link>
                            </li>
                            <li class="flex">
                                <router-link to="/edit-profile" class="flex">
                                    <img src="../assets/img/edit.svg" alt="edit icon">
                                    <div class="dropdown-text">{{ $t(`MainSlot['Edit profile']`) }}</div>
                                </router-link>
                            </li>
                            <!--                            <li class="flex">-->
                            <!--                                <a href="#" class="flex">-->
                            <!--                                    <img src="../assets/img/deactivate.svg" alt="deactivate icon">-->
                            <!--                                    <div class="dropdown-text">{{ $t(`MainSlot['Deactivate account']`) }}</div>-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                            <li class="flex">
                                <a @click="openLogoutModal" class="flex">
                                    <img src="../assets/img/logout.svg" alt="logout icon">
                                    <div class="dropdown-text">{{ $t(`MainSlot['Log out']`) }}</div>
                                </a>
                            </li>
                        </ul>
                        <div
                            class="sidenav-trigger menu_mobile"
                            data-target="slide-out"
                        >
                            <img src="../assets/img/menu.svg" alt="menu-button">
                        </div>
                    </div>
                </template>

            </div>
        </nav>

        <slot></slot>
        <footer v-if="isLogged || show_footer">
            <div class="copyright_row">
                2022 © Digital Speedfriending Inc. All rights reserved.
            </div>
        </footer>

        <!-- modal logout -->
        <div id="logout" ref="logout" class="modal content-width small">
            <div class="modal_header">
                {{ $t(`MainSlot['Log out']`) }}
            </div>
            <div class="modal-content">
                <p>{{ $t(`MainSlot['Are you sure you want to log out?']`) }}</p>
                <div class="buttons_wrapper_between two">
                    <div
                        @click="modals.logout.close()"
                        class="btn white mr30">
                        {{ $t(`buttons['Cancel']`) }}
                    </div>
                    <div
                        @click="logout"
                        class="btn">
                        {{ $t(`buttons['Confirm']`) }}
                    </div>
                </div>
            </div>
        </div>

        <div id="nearest" ref="nearest" class="modal content-width nearest">
            <div class="modal_header"
                 :style="{
                background: nearest_header_background
            }"
            >
            </div>
            <div class="modal-content">
                <div class="image_wrapper col s12">
                    <img :src="currentEventImageUrl" alt="image">
                    <div class="content_box">
                        <div class="title">
                            {{ timers.event.title }}
                        </div>
                    </div>
                    <div class="timer_info_box_wrapper">
                        <div class="timer_info_box">
                            <div class="icon_box">
                                <img src="../assets/img/timer.svg" alt="timer">
                            </div>
                            <div class="content">
                                <div class="title">
                                    {{ $t(`MainSlot['Event will start in']`) }}
                                </div>
                                <div class="info">
                                    {{ timers.event_started_at }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-if="timers.event.tags && timers.event.tags.length" class="col s12 input-field tags_wrapper">
                        <div
                            v-for="tag of timers.event.tags"
                            class="app_tag">
                            <img src="../assets/img/tag-icon.svg" class="left" alt="tag-icon" aria-hidden="true">
                            <div class="title">{{ tag.title }}</div>
                        </div>
                    </div>
                    <div class="col s12 m6 dress_desc_block">
                        <DresscodeWidget :event="timers.event"/>
                        <div class="ev_description">
                            {{ timers.event.description }}
                        </div>
                    </div>
                    <div class="col s12 m6">
                        <EventInfoWidget
                            :event="timers.event"
                            :btn_wrapper="{view_btn_wrapper: true}"
                        />
                    </div>
                </div>
                <div v-if="opened_nearest_is_five" class="buttons_wrapper_between center">
                    <div
                        @click="redirectToEventPageHandler"
                        class="btn to_event">
                        {{ $t(`MainSlot['To event page']`) }}
                    </div>
                </div>
                <div v-else class="buttons_wrapper_between two">
                    <div
                        @click="cancelReserveSeatConfirmModal"
                        class="btn white mr30">
                        {{ $t(`buttons['Cancel reservation']`) }}
                    </div>
                    <div
                        @click="modals.nearest.close()"
                        class="btn">
                        {{ $t(`buttons['OK']`) }}
                    </div>
                </div>
            </div>
        </div>

        <div id="success_reservation_modal_main" ref="success_reservation_modal_main" class="modal content-width">
            <div class="modal_header">
                {{ $t("MainSlot['Reserve a seat']") }}
            </div>
            <div class="modal-content">
                <p class="content_title">{{ $t("MainSlot['Congratulations!']") }}</p>

                <p>
                    {{ $t("MainSlot['You have reserved a seat at a new event.']") }} <br>
                    {{ $t("MainSlot['You can cancel your reservation at any time.']") }}
                </p>
                <div class="buttons_wrapper_between center">
                    <div @click="close_success_reservation_modal"
                         class="btn w180">
                        {{ $t(`buttons.OK`) }}
                    </div>
                </div>
            </div>
        </div>

        <div id="confirm_reservation_cancel_main" ref="confirm_reservation_cancel_main" class="modal content-width">
            <div class="modal_header">
                {{ $t("MainSlot['Cancel reservation']") }}
            </div>
            <div class="modal-content">
                <p v-html="generateCancelConfirmContent"></p>

                <div class="buttons_wrapper_between">
                    <div
                        @click="close_confirm_reservation_cancel"
                        class="btn white mr30">
                        {{ $t(`buttons.No`) }}
                    </div>
                    <div
                        @click="cancelReserveSeatConfirmed"
                        class="btn">
                        {{ $t(`buttons.Yes`) }}
                    </div>
                </div>
            </div>
        </div>

        <div id="success_reservation_cancel_main" ref="success_reservation_cancel_main" class="modal content-width">
            <div class="modal_header">
                {{ $t("MainSlot['Cancel reservation']") }}
            </div>
            <div class="modal-content">
                <p>
                    {{ $t("MainSlot['Your reservation was successfully canceled.']") }}
                </p>

                <div class="buttons_wrapper_between center">
                    <div
                        @click="close_success_reservation_cancel"
                        class="btn white mr30">
                        {{ $t(`buttons.OK`) }}
                    </div>
                </div>
            </div>
        </div>

        <!-- dropdown menu mobile -->
        <div id="slide-out"
             ref="menu_mobile"
             class="sidenav">
            <div class="main_content">
                <router-link to="/events-app" @click="closeMobileMenu">
                    <span><img src="../assets/img/events.svg" alt="events icon"></span>
                    <span>
                        {{ $t(`MainSlot['Events']`) }}
                    </span>
                </router-link>
                <router-link to="/calendar" @click="closeMobileMenu">
                    <span><img src="../assets/img/calendar.svg" alt="calendar icon"></span>
                    <span>{{ $t(`MainSlot['My Calendar']`) }}</span>
                </router-link>
                <router-link to="/friends" @click="closeMobileMenu">
                    <span><img src="../assets/img/matches.svg" alt="matches icon"></span>
                    <span>{{ $t(`Friends['Friendzone']`) }}</span>
                </router-link>
                <!--                <p @click="closeMobileMenu">-->
                <!--                    <span><img src="../assets/img/invite.svg" alt="invite icon"></span>-->
                <!--                    <a href="#!">{{ $t(`MainSlot['Invite a friend']`) }}</a>-->
                <!--                </p>-->
                <router-link to="/profile" @click="closeMobileMenu">
                    <span><img src="../assets/img/user_mobile_icon.svg" alt="user icon"></span>
                    <span>{{ $t(`MainSlot['My profile']`) }}</span>
                </router-link>
                <router-link to="/edit-profile" @click="closeMobileMenu">
                    <span><img src="../assets/img/edit.svg" alt="user edit"></span>
                    <span to="/edit-profile">{{ $t(`MainSlot['Edit profile']`) }}</span>
                </router-link>
                <!--                <p @click="closeMobileMenu">-->
                <!--                    <span><img src="../assets/img/deactivate.svg" alt="deactivate icon"></span>-->
                <!--                    <a href="#!">{{ $t(`MainSlot['Deactivate account']`) }}</a>-->
                <!--                </p>-->
                <p @click="openLogoutModal">
                    <span><img src="../assets/img/logout.svg" alt="logout icon"></span>
                    <span>{{ $t(`MainSlot['Log out']`) }}</span>
                </p>
            </div>
            <div class="footer_mobile">
                <a href="#">{{ $t(`MainSlot['Who we are?']`) }}</a>
                <a href="#">{{ $t(`MainSlot['Terms and Conditions']`) }}</a>
                <a href="#">{{ $t(`MainSlot['Quick Privacy Settings']`) }}</a>
                <a href="#">{{ $t(`MainSlot['Help Center']`) }}</a>
            </div>
            <div
                @click="closeMobileMenu"
                class="close_mobile_menu_btn">
                <img src="../assets/img/close.svg" alt="close mobile menu button">
            </div>
        </div>

        <!-- modal meeting_error -->
        <div id="meeting_error" ref="meeting_error" class="modal content-width">
            <div class="modal_header">
                {{ $t(`MainSlot['Meeting Error']`) }}
                <!-- close modal -->
                <div @click="closeMeetingErrorModal" class="close_modal_btn">
                    <svg
                        width="17.343" height="17.343" viewBox="0 0 12 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="modal-content">
                <div class="description">
                    {{ get_meeting_error_text }}
                </div>

                <div class="buttons_wrapper justify-content-center">
                    <div
                        @click="closeMeetingErrorModal"
                        class="btn">
                        {{ $t(`buttons['Close']`) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment-timezone";
import EventInfoWidget from "./EventInfoWidget";
import DresscodeWidget from "./DresscodeWidget";
import {errorMessage} from "../services/messges";
import event_modal_data from "../store/event_modal_data.js";
import {getBrowserLanguages} from "../utils/tools";

export default {
    data() {
        return {
            dropdown_open: false,
            avatar: null,
            is_abort: false,
            modals: {
                logout: null,
                nearest: null,
                success_reservation_modal_main: null,
                success_reservation_cancel_main: null,
                confirm_reservation_cancel_main: null,
                reservation_modal: null,
                nearest_is_opened: false,
                currentInterval: null,
                current_modal_content: {},
                available_contents: event_modal_data,
                change_password: null,
                success_change_password: null,
                change_email: null,
                success_change_email: null,
                meeting_error: null
            },
            mobile_menu: null,
            old_password: null,
            password: null,
            current_email: null,
            new_email: null,
            confirm_password: null,
            timers: {
                event_started_at: '',
                nearest: {},
                event: {}
            }
        };
    },
    props: {
        forceLogout: {
            type: Boolean,
            default: false,
            required: false
        },
        body_classes: {
            type: String,
            default: '',
            required: false
        },
        background_image_url: {
            type: String,
            default: '',
            required: false
        },
        border_height: {
            default: 4,
            required: false
        },
        show_footer: {
            default: false,
            required: false,
            type: Boolean
        }
    },
    components: {
        EventInfoWidget, DresscodeWidget
    },
    mounted() {
        // TODO: uncomment checkLanguage when langs will be accepted
        // this.checkLanguage();
        this.reInitModals();
        this.reInitMobileMenu();

        if (this.isLoginChecked) {
            this.afterLoginChecked();
        }
    },
    methods: {
        ...mapMutations([
            "setLogged",
            "setLoginChecked",
            'setLoading',
            'set_refresh_event_status',
            'set_meeting_error',
        ]),
        ...mapActions([
            'loadNearestMeetingsInfo',
            'loadUserInfo',
        ]),
        close_success_reservation_modal() {
            this.modals.success_reservation_modal_main?.close();
        },
        destroySuccessReservationModal() {
            if (this.modals.success_reservation_modal_main) {
                this.modals.success_reservation_modal_main?.destroy();
                this.modals.success_reservation_modal_main = null;
            }
        },
        openSuccessReservationModal() {
            this.modals.success_reservation_modal_main?.open()
            this.loadNearestMeetingsInfo(true);
        },
        checkLanguage() {
            let storedLanguage = localStorage.getItem('lang');
            const availableLocales = this.$i18n.availableLocales || [];
            if (storedLanguage) {
                if (availableLocales.some(l => l === storedLanguage)) {
                    this.setLang(storedLanguage);
                } else {
                    storedLanguage = null;
                }
            }
            if (!storedLanguage) {
                const lang = this.getLangByBrowser();
                this.setLang(lang);
            }
        },
        setLang(lang) {
            localStorage.setItem('lang', lang);
            this.$i18n.locale = lang;
            axios.defaults.headers.common['Accept-Language'] = lang
            document.querySelector('html').setAttribute('lang', lang)
        },
        getLangByBrowser() {
            const availableLocales = this.$i18n.availableLocales || [];
            const {language, languages} = getBrowserLanguages();
            if (availableLocales.some(l => l === language)) {
                return language;
            }
            for (const lang of languages) {
                if (availableLocales.some(l => l === lang)) {
                    return lang;
                }
            }
            return null;
        },
        toggleLangHandler() {
            this.$i18n.locale = this.$i18n.locale === 'ru' ? 'en' : 'ru';
        },
        destroyDropdown() {
            if (this.dropdown) {
                this.dropdown?.destroy();
                this.dropdown = null;
            }
        },
        initLoggedDropdown() {
            this.destroyDropdown();
            const el = document.querySelector('.dropdown-trigger-main-menu');
            this.dropdown = M.Dropdown.init(el, {
                alignment: 'right',
                constrainWidth: false,
                onOpenStart: () => {
                    this.dropdown_open = true;
                    this.$refs.dropdown.style.width = '195px';
                    this.$refs.dropdown.style.top = '60px';
                },
                onOpenEnd: () => {
                    this.$refs.dropdown.style.top = '60px';
                },
                onCloseStart: () => {
                    this.dropdown_open = false;
                }
            });
        },
        createObjectURL(file) {
            if (file) {
                return URL.createObjectURL(file);
            }
            return false;
        },
        destroyReservationModal() {
            if (this.modals.reservation_modal) {
                this.modals.reservation_modal?.destroy();
                this.modals.reservation_modal = null;
            }
        },
        destroyMeetingErrorModal() {
            if (this.modals.meeting_error) {
                this.modals.meeting_error?.destroy();
                this.modals.meeting_error = null;
            }
        },
        runFunc(name) {
            try {
                if (name) {
                    this[name]();
                }
            } catch (e) {
                console.log(e);
            }
        },
        closeReservationModal() {
            this.modals.reservation_modal?.close()
        },
        async redirectToEventPageHandler() {
            try {
                this.modals.nearest?.close();
                await this.$router.push(`/events-app/${this.timers.event.id}/details`);
            } catch (e) {
                console.log(e);
            }
        },
        openReservationModal() {
            this.modals.reservation_modal?.open()
            this.loadNearestMeetingsInfo(true);
        },
        cancelReserveSeatConfirmModal() {
            this.modals.current_modal_content = this.modals.available_contents.confirm_reservation_cancel;
            this.openConfirmReservationCancelModal();
        },
        cancelReserveSeatConfirmed() {
            this.close_confirm_reservation_cancel();
            this.modals.current_modal_content = this.modals.available_contents.success_reservation_cancel;
            this.reservation(false, 'open_success_reservation_cancel');
        },
        reserveSeat() {
            this.modals.current_modal_content = this.modals.available_contents.success_reservation;
            this.reservation(true, 'openSuccessReservationModal')
        },
        async afterLoginChecked() {
            if (this.is_abort) {
                return;
            }
            await this.loadUserInfo();
            if (this.is_abort) {
                return;
            }
            await this.loadNearestMeetingsInfo();
            if (this.is_abort) {
                return;
            }
            this.initLoggedDropdown();
            if (this.getNearestMeetingsInfo && this.getNearestMeetingsInfo.length) {
                this.reInitNearestTimers();
            }
        },
        closeMobileMenu() {
            this.mobile_menu?.close();
        },
        destroyMobileMenu() {
            if (this.mobile_menu) {
                this.mobile_menu?.close();
                this.mobile_menu?.destroy();
                this.mobile_menu = null;
            }
        },
        reInitMobileMenu() {
            this.destroyMobileMenu();

            this.mobile_menu = M.Sidenav.init(this.$refs.menu_mobile);
        },
        async logout() {
            delete localStorage.jwt;
            delete localStorage.user;
            this.modals.logout?.close();
            this.closeMobileMenu();
            this.setLogged(false);
            this.setLoginChecked(false);
            await this.$router.push('/');
        },

        async updatePassword() {
            try {
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/user/change_password`, {
                    old_password: this.old_password,
                    password: this.password,
                    password_confirm: this.confirm_password,
                });
                if (response && response.data && response.data.success) {
                    this.modals.change_password.close();
                    this.old_password = null;
                    this.password = null;
                    this.confirm_password = null;
                    this.openSuccessChangePasswordModal();
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t(`MainSlot['OOPS... Something went wrong...']`));
            }
            this.setLoading(false);
        },
        async updateEmail() {
            try {
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/user/change_email`, {
                    current_email: this.current_email,
                    new_email: this.new_email,
                    password_confirm: this.confirm_password,
                });
                if (response && response.data && response.data.success) {
                    this.current_email = null;
                    this.new_email = null;
                    this.confirm_password = null;
                    this.modals.change_email.close();
                    this.openSuccessChangeEmailModal();
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t(`MainSlot['OOPS... Something went wrong...']`));
            }
            this.setLoading(false);
        },
        openLogoutModal() {
            this.closeMobileMenu();
            if (!this.modals.logout) {
                this.reInitModals();
            }
            this.modals.logout.open();
        },
        openChangePasswordModal() {
            this.closeMobileMenu();
            if (!this.modals.change_password) {
                this.reInitModals();
            }
            this.modals.change_password.open();
        },
        closeChangePasswordModal() {
            this.old_password = null;
            this.password = null;
            this.confirm_password = null;

            this.$refs.form_change_password.reset();
            this.modals.change_password.close();
        },
        openSuccessChangePasswordModal() {
            if (!this.modals.success_change_password) {
                this.reInitModals();
            }
            this.modals.success_change_password.open();
        },
        openChangeEmailModal() {
            this.closeMobileMenu();
            if (!this.modals.change_email) {
                this.reInitModals();
            }
            this.modals.change_email.open();
        },
        openMeetingErrorModal() {
            this.closeMobileMenu();
            if (!this.modals.meeting_error) {
                this.reInitModals();
            }
            this.modals.meeting_error?.open();
        },
        closeChangeEmailModal() {
            this.current_email = '';
            this.new_email = '';
            this.confirm_password = '';

            this.$refs.form_change_email.reset();
            this.modals.change_email.close();
        },
        closeMeetingErrorModal() {
            this.set_meeting_error(null);
            this.modals.meeting_error?.close();
        },
        openSuccessChangeEmailModal() {
            if (!this.modals.success_change_email) {
                this.reInitModals();
            }
            this.modals.success_change_email.open();
        },
        destroyChangePasswordModal() {
            if (this.modals.change_password) {
                this.modals.change_password?.close();
                this.modals.change_password?.destroy();
                this.modals.change_password = null;
            }
        },
        destroySuccessChangePasswordModal() {
            if (this.modals.success_change_password) {
                this.modals.success_change_password?.close();
                this.modals.success_change_password?.destroy();
                this.modals.success_change_password = null;
            }
        },
        destroyChangeEmailModal() {
            if (this.modals.change_email) {
                this.modals.change_email?.close();
                this.modals.change_email?.destroy();
                this.modals.change_email = null;
            }
        },
        destroySuccessChangeEmailModal() {
            if (this.modals.success_change_email) {
                this.modals.success_change_email?.close();
                this.modals.success_change_email?.destroy();
                this.modals.success_change_email = null;
            }
        },
        destroyLogoutModal() {
            if (this.modals.logout) {
                this.modals.logout?.close();
                this.modals.logout?.destroy();
                this.modals.logout = null;
            }
        },
        destroyNearestModal() {
            if (this.modals.nearest) {
                this.modals.nearest?.close();
                this.modals.nearest?.destroy();
                this.modals.nearest = null;
            }
        },
        clearModalInterval() {
            clearInterval(this.modals.currentInterval);
            this.modals.currentInterval = null;
        },
        reInitModals() {
            this.destroyMeetingErrorModal();
            this.modals.meeting_error = M.Modal.init(this.$refs.meeting_error);
            this.destroyReservationModal();
            this.modals.reservation_modal = M.Modal.init(this.$refs.reservation_modal_main);
            this.destroyLogoutModal();
            this.modals.logout = M.Modal.init(this.$refs.logout);
            this.destroyChangePasswordModal();
            this.destroyNearestModal();
            this.modals.nearest = M.Modal.init(this.$refs.nearest, {
                onCloseStart: () => {
                    this.modals.nearest_is_opened = false;
                    this.clearModalInterval();
                },
                onOpenStart: () => {
                    this.modals.nearest_is_opened = true;
                },
                onOpenEnd: () => {
                    this.$refs.nearest.style.top = '6%';
                    this.$refs.nearest.style.height = '88%';
                    this.$refs.nearest.style['max-height'] = '88%';
                }
            });
            this.destroySuccessReservationModal();
            this.modals.success_reservation_modal_main = M.Modal.init(this.$refs.success_reservation_modal_main);
            this.destroySuccessReservationCancelModal();
            this.modals.success_reservation_cancel_main = M.Modal.init(this.$refs.success_reservation_cancel_main);
            this.destroyConfirmReservationModal();
            this.modals.confirm_reservation_cancel_main = M.Modal.init(this.$refs.confirm_reservation_cancel_main);
        },
        destroyConfirmReservationModal() {
            if (this.modals.confirm_reservation_cancel_main) {
                this.modals.confirm_reservation_cancel_main?.destroy();
                this.modals.confirm_reservation_cancel_main = null;
            }
        },
        openConfirmReservationCancelModal() {
            this.modals.confirm_reservation_cancel_main?.open();
        },
        close_confirm_reservation_cancel() {
            this.modals.confirm_reservation_cancel_main?.close();
        },
        destroySuccessReservationCancelModal() {
            if (this.modals.success_reservation_cancel_main) {
                this.modals.success_reservation_cancel_main?.destroy();
                this.modals.success_reservation_cancel_main = null;
            }
        },
        open_success_reservation_cancel() {
            this.modals.success_reservation_cancel_main?.open();
            this.loadNearestMeetingsInfo(true);
        },
        close_success_reservation_cancel() {
            this.modals.success_reservation_cancel_main?.close();
        },
        isFiveMinutesInterval(event) {
            return this.getDiff(event) <= 302000;
        },
        getDiff(event) {
            return moment(event.start_date_time).diff(moment());
        },
        getNextReInitPoint() {
            const current_event_diff = this.getDiff(this.timers.event);
            if (current_event_diff <= 303000) {
                return current_event_diff;
            } else if (current_event_diff <= 7203000) {
                return current_event_diff - 300000;
            } else {
                return current_event_diff - 7200000;
            }
        },
        drawEventPopup(event) {
            if (this.modals.nearest_is_opened && this.timers.event.id !== event.id) {
                const new_event_diff = this.getDiff(event);
                const current_event_diff = this.getDiff(this.timers.event);

                if (current_event_diff < new_event_diff && event.id !== this.timers.event.id) {
                    return;
                } else {
                    this.clearModalInterval();
                    this.modals.nearest?.close();
                }
            }
            this.timers.event = event;
            this.calculate_event_started_at();
            const redraw_interval = this.isFiveMinutesInterval(event) ? 1000 : 60000;
            let next_time_point = this.getNextReInitPoint();
            this.clearModalInterval();
            this.modals.currentInterval = setInterval(() => {
                this.calculate_event_started_at();
                next_time_point -= redraw_interval;
                if (next_time_point < redraw_interval) {
                    this.clearModalInterval();
                    this.reInitNearestTimers();
                }
            }, redraw_interval)
            this.modals.nearest?.open();
        },
        reInitNearestTimers(events_arr) {
            if (!events_arr) {
                events_arr = this.getNearestMeetingsInfo;
            }
            this.clearTimers();
            this.modals.nearest?.close();
            for (const event of events_arr) {
                const timeout = this.calculateTimeout(event) * 1000;
                if (timeout >= 0) {
                    this.timers.nearest[event.id] = setTimeout(() => {
                            this.drawEventPopup(event);
                        },
                        timeout
                    );
                }
            }
        },
        calculateTimeout(event) {
            const five_min = 300; // sec 5 min
            const two_hour = 7200; // sec 2 hour
            const day = 86400; // sec in 1 day
            const diff = this.getDiff(event);
            const diff_sec = Math.floor(diff / 1000);
            if (diff_sec < five_min) {
                return -1;
            }
            if (diff_sec >= day) {
                return diff_sec - day;
            } else if (diff_sec >= two_hour) {
                return diff_sec - two_hour;
            } else {
                return diff_sec - five_min;
            }
        },
        clearTimers() {
            if (this.timers && this.timers.nearest && Object.keys(this.timers.nearest).length) {
                for (const key of Object.keys(this.timers.nearest)) {
                    clearTimeout(this.timers.nearest[key]);
                }
            }
            this.timers.nearest = {};
        },
        nextMinuteTimeout() {
            const next_min = moment().add(1, 'minutes').set({second: 0});
            return next_min.diff(moment());
        },
        calculate_event_started_at() {
            const start_tme = moment(this.timers.event.start_date_time);
            let diff_seconds = Math.floor(start_tme.diff(moment()) / 1000);
            if (diff_seconds <= 0) {
                diff_seconds = 0;
                this.modals.nearest?.close();
            }
            const diff_minutes = Math.floor(diff_seconds / 60);
            const hours = Math.floor(diff_minutes / 60);
            const minutes = diff_minutes % 60;
            const seconds = diff_seconds % 60;
            let result_string = '';
            if (hours) {
                result_string += `${hours} hour`;
                if (hours > 1) {
                    result_string += 's';
                }
                result_string += ' ';
            }
            if (this.isFiveMinutesInterval(this.timers.event)) {
                if (minutes) {
                    result_string += `${minutes} mins `;
                }
                result_string += `${seconds} sec`;
            } else {
                if (minutes < 10) {
                    result_string += '0';
                }
                result_string += `${minutes} mins`;
            }

            this.timers.event_started_at = result_string;
        },
        cancelReservation() {

        },
        async reservation(is_reserve, on_success = null) {
            const event_id = this.timers.event.id;
            try {
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/events-app/${event_id}/reserve`, {
                    remove: !is_reserve
                });
                if (response && response.data && response.data.success) {
                    this.set_refresh_event_status({
                        id: event_id,
                        is_reserved: is_reserve
                    });
                    if (on_success) {
                        this[on_success]();
                    }
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t(`MainSlot['OOPS... Something went wrong...']`));
            }
            this.setLoading(false);
        },
        abort() {
            try {
                this.is_abort = true;
                const abort_controller = new AbortController();
                if (abort_controller) {
                    abort_controller.abort();
                }
            } catch (e) {
                console.log(e);
            }
        }
    },
    beforeDestroy() {
        this.abort();
        this.destroyDropdown();
        this.destroyLogoutModal();
        this.destroyChangePasswordModal();
        this.destroyNearestModal();
        this.clearTimers();
        this.destroyMobileMenu();
        this.destroySuccessReservationModal();
        this.destroySuccessReservationCancelModal();
        this.destroyConfirmReservationModal();
    },
    computed: {
        ...mapGetters([
            'isLogged',
            'isLoginChecked',
            'getNearestMeetingsInfo',
            'get_last_nearest_meeting_load_time',
            'getUserInfo',
            'get_meeting_error_text'
        ]),
        generateCancelConfirmContent() {
            return `${this.$t("MainSlot['Are you sure you want to cancel your reservation for']")} <span class="strong">”${this.timers.event.title}” ${this.$t("MainSlot['on']")} ${this.eventDate}<strong>?`;
        },
        eventDate() {
            const date = moment(this.timers.event.start_date_time);
            return `${date.format('MMM DD, YYYY')}`;
        },
        opened_nearest_is_five() {
            return this.isFiveMinutesInterval(this.timers.event);
        },
        currentEventImageUrl() {
            return this.timers.event?.image?.url || '';
        },
        avatar_menu_background() {
            const user = this.user = this.getUserInfo;
            const url = user?.url_avatar || '';
            return `url(${url}) no-repeat center / cover`;
        },
        nearest_header_background() {
            const url = this.timers.event?.image?.url || '';

            return `linear-gradient(90deg, #FA604Acc 0%, #9235A1cc 100%),  url(${url}) no-repeat center / cover`;
        },
        custom_header_background() {
            if (!this.background_image_url) {
                return 'linear-gradient( 90deg, #FA604A 0%, #9235A1 100%)';
            }
            return `linear-gradient( 90deg, #FA604A77 0%, #9235A177 100%), linear-gradient(180deg, rgba(250, 96, 74, 0.95) 22.57%, rgba(146, 53, 161, 0.5) 100%), url('${this.background_image_url}') no-repeat center / cover`;
        }
    },
    watch: {
        get_meeting_error_text(val) {
            if (val) {
                this.openMeetingErrorModal()
            } else {
                this.closeMeetingErrorModal();
            }
        },
        forceLogout(val) {
            if (val) {
                this.logout();
            }
        },
        isLoginChecked(val) {
            if (val) {
                this.afterLoginChecked();
            }
        },
        getNearestMeetingsInfo(val) {
            if (val && val.length) {
                this.reInitNearestTimers(val);
            }
        }
    },
    name: "MainSlot"
}
</script>

<style lang="scss" scoped>

.to_event {
    min-width: 202px;
}

#dropdown {
    width: 195px;
    top: 59px !important;
    max-height: calc(100vh - 60px) !important;
    z-index: 999;

    li {
        padding-left: 20px;

        & > a {
            padding: 15px 0px;
            align-items: center;

            & > img {
                margin-right: 12px;
            }
        }
    }
}

#user_menu_desktop {
    justify-content: space-between;
    padding: 2px;
    min-width: 72px !important;
    max-width: 72px !important;
    z-index: 2;
    background-color: #ffffff !important;

    img {

    }
}

.description {
    font-weight: bold;
    font-size: 15px;
    line-height: 20px;
    color: #B8B5C8;
    padding: 40px 0;
    text-align: center;
}

#nearest {
    width: 730px;
    max-width: 92%;
    top: 6%;
    height: 88%;
    max-height: 88%;
    margin: 0 auto;

    .modal-content {
        background: none;
        width: 100%;
    }

    .image_wrapper {
        position: relative;
        height: 380px;
        display: flex;
        margin: 0 auto;
        //width: fit-content;
        filter: drop-shadow(3px 6px 12px rgba(58, 1, 67, 0.15));
        border-radius: 12px;
        overflow: hidden;
        align-items: center;
        justify-content: center;

        .timer_info_box_wrapper {
            position: absolute;
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .timer_info_box {
                padding: 20px 0 20px 30px;
                width: 348px;
                max-width: 95%;
                min-height: 100px;
                background: rgba(39, 39, 39, 0.6);
                border-radius: 24px;
                display: flex;
                align-items: center;

                .content {
                    padding: 0 0 0 20px;

                    .info {
                        font-style: normal;
                        font-weight: 600;
                        font-size: 32px;
                        line-height: 40px;
                        color: #FFFFFF;
                    }

                    .title {
                        font-style: normal;
                        font-weight: bold;
                        font-size: 15px;
                        line-height: 20px;
                        color: #B8B5C8;
                    }
                }

                .icon_box {
                    background: #FFFFFF;
                    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.15);
                    border-radius: 12px;
                    width: 60px;
                    height: 60px;
                    min-width: 60px;
                    min-height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 38px;
                        height: 38px;
                    }
                }
            }
        }

        .content_box {
            position: absolute;
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding: 30px;

            .title {
                font-style: normal;
                font-weight: bold;
                font-size: 22px;
                line-height: 28px;
                color: white;
            }
        }

        img {
            width: auto;
            //max-width: 100%;
            height: 380px;
            max-height: 380px;
        }
    }

    .modal_header {
        height: 145px;
        margin-bottom: -115px;
        z-index: -1;
    }

    @media screen and (max-width: 600px) {
        .tags_wrapper, .dress_desc_block {
            display: none;
        }

        .image_wrapper, .col.image_wrapper {
            margin-bottom: 15px;
        }
    }
}

#logout {
    .buttons_wrapper_between {
        position: relative;

        .btn {
            @media screen and (max-width: 601px) {
                width: calc(50% - 15px);
                max-width: calc(50% - 15px);
                min-width: calc(50% - 15px);
            }
        }
    }
}

.small {
    width: 30%;
}

#change_password {

    .modal_header {
        padding: 15px 18px;
    }

    .modal-content {
        padding: 24px 30px 30px 30px;

        .container {
            width: 100%;

            .row {
                margin-bottom: 8px;
            }
        }

        .input-field {
            .active {
                margin-top: -4px;
            }
        }
    }

    .buttons_wrapper {
        .btn {
            max-width: 177px;
            height: 56px;
            margin: 0 auto;
        }
    }
}

#success_change_password {
    width: 540px;

    .modal_header {
        padding: 15px 18px;
    }

    .content_title {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        color: #555A63;
        padding-bottom: 30px;
    }

    .buttons_wrapper {
        .btn {
            max-width: 177px;
            height: 56px;
            margin: 0 auto;
        }
    }
}

#change_email {
    width: 540px;

    .modal_header {
        padding: 15px 18px;
        margin-bottom: -2px;
    }

    .modal-content {
        padding: 24px 30px 30px 30px;

        .row {
            margin-bottom: 8px;
        }

        .input-field {
            margin-bottom: 10px;

            .active {
                margin-top: -4px;
            }
        }
    }

    .input-field {
        margin-bottom: 2em;

        &.last {
            margin-bottom: 1em;
        }
    }

    .buttons_wrapper {
        .btn {
            max-width: 177px;
            height: 56px;
            margin: 0 auto;
        }
    }
}

#success_change_email {
    width: 540px;

    .modal_header {
        padding: 15px 18px;
    }

    .content_title {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        color: #555A63;
        padding-bottom: 30px;
    }

    .buttons_wrapper {
        .btn {
            max-width: 177px;
            height: 56px;
            margin: 0 auto;
        }
    }
}

.sidenav {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    height: 100%;

    .main_content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        margin-bottom: 110px;

        & > p, & > a {
            display: flex;
            align-items: center;
            margin: 0;
            padding: 15px 30px;

            span {
                margin-right: 10px;
            }
        }

        a {
            font-weight: normal;
            font-size: 15px;
            line-height: 20px;
            color: #555A63;
            text-align: left;
        }
    }

    .footer_mobile {
        width: 75%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;

        a {
            margin: 5px 0;
            font-weight: bold;
            font-size: 13px;
            line-height: 16px;
            color: #FA604A;
        }
    }

    .close_mobile_menu_btn {
        position: absolute;
        top: 20px;
        right: 20px;
        height: 24px;
        width: 24px;
        padding: 0;
        margin: 0;

        img {
            height: 24px;
            width: 24px;
        }
    }
}

.menu_mobile {
    cursor: pointer;
    display: none;

    @media screen and (max-width: 601px) {
        display: flex;
    }
}

footer {
    width: 100%;
    height: 80px;
    background: linear-gradient(90deg, #FA604A 0%, #9235A1 100%);
    display: flex;
    align-items: center;

    @media screen and (max-width: 601px) {
        display: none;
    }

    .links_row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            font-weight: bold;
            font-size: 15px;
            line-height: 20px;
            color: white;
            cursor: pointer;
            padding: 15px;
        }
    }

    .copyright_row {
        font-size: 13px;
        line-height: 16px;
        color: rgba(255, 255, 255, 0.75);
        width: 100%;
        text-align: center;
    }
}

.modal-content p {
    margin: 30px 0;
}

.mr30 {
    margin-right: 30px;
}

.nav_menu {
    padding-right: 15px;

    @media screen and (max-width: 601px) {
        display: none;
    }

    a {
        color: #FFFFFF;
        opacity: 0.75;
        padding: 8px;
        margin: 0 17px;
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;

        &.router-link-exact-active {
            border-bottom: 2px solid white;
        }

        @media screen and (max-width: 668px) {
            margin: 0 8px;
        }

        &:hover {
            opacity: 1;
        }
    }
}

.nav_friending {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;

    @media screen and (max-width: 601px) {
        height: 54px;
    }
}

nav {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: rgba(0, 0, 0, 0) linear-gradient(90deg, rgb(250, 96, 74) 0%, rgb(146, 53, 161) 100%) repeat scroll 0% 0%;
    border-bottom: 4px solid white;
    -webkit-box-shadow: 0px 15px 31px 0px rgba(218, 222, 237, 1);
    -moz-box-shadow: 0px 15px 31px 0px rgba(218, 222, 237, 1);
    box-shadow: 0px 15px 31px 0px rgba(218, 222, 237, 1);

    & ul a:hover {
        background-color: initial;
    }
}

.nav_menu_wrapper {
    display: flex;
    height: 100%;
    align-items: center;

    @media screen and (max-width: 601px) {
        margin-right: -1rem;
    }

    .avatar-image {
        width: 36px;
        height: 36px;
        left: 2px;
        top: 2px;
        border-radius: 10px;
    }

    .dropdown-trigger-main-menu.opened {
        border-radius: 12px 12px 0 0;
    }

    .flex {
        display: flex;

        &.first {
            margin-top: 15px;
        }
    }

    .dropdown-content {
        border-radius: 12px 0 12px 12px;
        background-color: #fff;

        li > span {
            padding: 10px 0 10px 20px;
        }

        .dropdown-text {
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 20px;
            text-align: center;
            color: #555A63;
        }

    }

    .logout {
        @media screen and (max-width: 601px) {
            display: none;
        }
    }
}

.brand_logo {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 25%;

    img {
        width: 100%;
    }

    @media screen and (max-width: 601px) {
        max-width: 50%;
        width: 50%;
    }
}

/* customization for the Meeting Results page */
.meeting_result {

    & > div:first-child nav {
        height: 280px;
    }

    .logged {
        min-height: auto;
        height: auto;
    }

    footer {
        position: relative;
        z-index: 2;
    }
}

@media screen and (max-width: 460px) {
    .more_460 {
        display: none;
    }
    .less_460 {
        display: block;
    }
}

@media screen and (min-width: 460px) {
    .more_460 {
        display: block;
    }
    .less_460 {
        display: none;
    }
}

@media screen and (max-width: 600px) {
    .meeting_result > div:first-child nav {
        height: 240px;
    }

    nav {
        .nav_friending {
            height: 51px;

            .sidenav-trigger {
                height: 23px;

                img {
                    max-width: 23px;
                }
            }
        }
    }
}

@media screen and (max-width: 400px) {
    .meeting_result > div:first-child nav {
        height: 175px;
    }
}


/*page my profile*/
.profile nav {
    height: 400px;
}

@media screen and (max-width: 767px) {
    .profile {
        nav {
            height: 190px;
        }
    }
}

</style>
